import styled from 'styled-components'
import ButtonComponent from '@/modern/components/Button'

export const Modal = styled.div`
  .modalCloseButton {
    top: 32px;
    right: 32px;
    width: 17px;
    height: 17px;
  }
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 570px;
  padding: 42px 32px;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`

export const Header = styled.strong`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  color: #2e2d37;
  font-size: 20px;
  font-family: Poppins;
  font-weight: 500;
  line-height: 150%;
  margin-top: 16px;
`

export const Info = styled.p`
  font-size: 12px;
  font-family: Poppins;
  line-height: 150%;
`

export const Button = styled(ButtonComponent)`
  margin-top: 16px;

  span {
    font-size: 12px;
    height: 40px;
  }
`
